import React from "react";
import {
  Box,
  Button,
  CircularProgress,
  IconButton,
  Tooltip,
} from "@mui/material";
import DevicesIcon from "@mui/icons-material/Devices";
import FingerprintIcon from "@mui/icons-material/Fingerprint";
import { FingerprintDevice } from "../utils/biometric";

interface FingerprintCaptureControlsProps {
  fingerprintDevice: FingerprintDevice | null;
  detectingDevice: boolean;
  capturingFingerprint: boolean;
  disabled?: boolean;
  onDetect: () => void;
  onCapture: () => void;
}

const FingerprintCaptureControls: React.FC<FingerprintCaptureControlsProps> = ({
  fingerprintDevice,
  detectingDevice,
  capturingFingerprint,
  disabled = false,
  onDetect,
  onCapture,
}) => {
  return (
    <Box
      display="flex"
      alignItems="center"
      gap={1}
      flexWrap="wrap"
      dir="ltr"
      sx={{ justifyContent: "flex-start", mb: 1 }}
    >
      <Tooltip
        title={
          fingerprintDevice
            ? `Device Ready: ${fingerprintDevice.name}`
            : "Detect Device"
        }
        placement="top"
        arrow
      >
        <span>
          <IconButton
            size="small"
            color={fingerprintDevice ? "success" : "primary"}
            onClick={onDetect}
            disabled={disabled || detectingDevice || capturingFingerprint}
            sx={{
              border: "1px solid",
              borderColor: fingerprintDevice ? "success.main" : "primary.main",
              borderRadius: "4px",
              width: 28,
              height: 28,
            }}
          >
            {detectingDevice ? (
              <CircularProgress size={14} color="inherit" />
            ) : (
              <DevicesIcon sx={{ fontSize: 16 }} />
            )}
          </IconButton>
        </span>
      </Tooltip>
      <Button
        size="small"
        variant="contained"
        startIcon={
          capturingFingerprint ? (
            <CircularProgress size={14} color="inherit" />
          ) : (
            <FingerprintIcon sx={{ fontSize: 16 }} />
          )
        }
        onClick={onCapture}
        disabled={
          disabled ||
          !fingerprintDevice ||
          detectingDevice ||
          capturingFingerprint
        }
        sx={{
          fontSize: "11px",
          textTransform: "none",
          py: 0.25,
          px: 1,
          minHeight: 28,
          fontFamily: "Poppins, sans-serif",
        }}
      >
        Capture Fingerprint
      </Button>
    </Box>
  );
};

export default FingerprintCaptureControls;
